import React from "react";
import Skeleton from "react-loading-skeleton";

export const Input = ({
  id,
  label,
  validationSchema,
  register,
  className,
  ...props
}) => {
  return (
    <>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <input
        id={id}
        type="text"
        className={`form-control ${className}`}
        {...props}
      />
    </>
  );
};

export const Textarea = ({
  id,
  label,
  validationSchema,
  register,
  rows = 3,
  ...props
}) => {
  return (
    <>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <textarea
        id={id}
        className="form-control"
        rows={rows}
        {...props}
      ></textarea>
    </>
  );
};

export const Select = ({
  id,
  label,
  loading,
  validationSchema,
  children,
  ...props
}) => {
  return (
    <>
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      {loading ? (
        <Skeleton width={200} className="mx-3" height={28} />
      ) : (
        <select id={id} className="form-select" {...props}>
          {children}
        </select>
      )}
    </>
  );
};
